import { Grid, Paper } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { useTranslation } from 'react-i18next';
import { AdminInvoiceGroupDataGrid } from '../components/adminInvoiceGroupDataGrid';
import AdminInvoiceTabNavigation from '../components/adminInvoiceTabNavigation';

export const AdminInvoiceGroupOverviewPage = () => {
  const { t } = useTranslation(['invoice']);

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <MainContentHeader title={t('invoice:adminInvoiceGroupOverviewPage.pageHeader')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <AdminInvoiceTabNavigation />
          <AdminInvoiceGroupDataGrid />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
